module.exports = __webpack_public_path__ + "img/overflow-menu.6ca03e4d.svg";